import React from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import DisplayCard from '../../../components/displaycard';

import Auth from '../../../data/auth-service';
import Permissions from '../../../data/permissions';

const options = [
    {
        title: 'CMC',
        description: 'Upgrade a CMC',
        img: '/images/update-cmc.png',
        route: '/system/upgrades/cmc',
        perm: {
            CMCUpgrades: [...Permissions.System.Upgrades.CMCUpgrades],
        },
    },
    {
        title: 'Data Node',
        description: 'Upgrade a data node',
        img: '/images/update-datanode.png',
        route: '/system/upgrades/datanode',
        perm: {
            DatanodeUpgrades: [...Permissions.System.Upgrades.DatanodeUpgrades]
        },
    },
];

const Upgrades = (props) => {
    return (
        <Box mb={2}>
            <Grid container spacing={5}>
                {options.filter(o => Auth.perm(o.perm)).map((p, i) => {
                    return (
                        <Grid item xs={3} key={`policies-zeek-${i}`}>
                            <DisplayCard aria-label={p.title} {...p} noButton />
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default Upgrades;
